import { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  differenceInDays,
  addMinutes,
  differenceInMinutes,
} from 'date-fns';
import Context from '../../context';
import './FlightListItem.scss';
import FlightIcon from '@mui/icons-material/Flight';

const FlightListItem = ({ data, isSelected, formatDate, formatTime }) => {
  const { viewMode, t, itin } = useContext(Context);
  const location = useLocation();

  const { departure, arrival, ...flight } = data;

  const cancelled = data.status === "Cancelled";

  const dateNow = new Date();
  const depScheduled = new Date(departure.scheduled);
  const depEstimated = new Date(departure.estimated);
  const arrScheduled = new Date(arrival.scheduled);
  const arrEstimated = new Date(arrival.estimated);

  const departureTimeEstimation = depEstimated !== depScheduled && depEstimated > dateNow;
  const arrivalTimeEstimation = arrEstimated !== arrScheduled && arrEstimated > dateNow;

  const rawAirportScheduled = addMinutes(depEstimated, (departure.airportTimeOffset * 60));
  const rawAirportArrival = addMinutes(arrEstimated, (arrival.airportTimeOffset * 60));

  const scheduledDate = addMinutes(rawAirportScheduled, rawAirportScheduled.getTimezoneOffset());
  const arrivalDate = addMinutes(rawAirportArrival, rawAirportArrival.getTimezoneOffset());

  const timeDifferenceDeparture = differenceInDays(depEstimated, dateNow);
  const isActive = timeDifferenceDeparture > -1 && timeDifferenceDeparture < 1 && arrEstimated > dateNow;

  const departureTimeTypeClassNames = `${!departureTimeEstimation && (depScheduled < dateNow ) ? 'time-active' : ''} ${departureTimeEstimation ? 'time-estimated' : ''} ${cancelled ? 'time-cancelled' : ''}`.trim();
  const arrivalTimeTypeClassNames = `${!departureTimeEstimation && (arrScheduled < dateNow ) ? 'time-active' : ''} ${arrivalTimeEstimation ? 'time-estimated' : ''} ${cancelled ? 'time-cancelled' : ''}`.trim();

  const generateTimeStr = (classNames, date) => {
    const prefixMap = [
      { className: "time-active", prefix: t('flights_actual_text', { lng: itin.language }) },
      { className: "time-estimated", prefix: t('flights_estimated_text', { lng: itin.language }) },
      { className: "time-cancelled", prefix: t('cancelled', { lng: itin.language }) },
    ];
    const prefix = prefixMap.find(x => classNames.endsWith(x.className))?.prefix || '';
    return `${prefix} ${!cancelled ? formatTime(date) : ''}`;
  };

  const differenceFromSchedule = (estimatedDate, scheduledDate, acceptableDifference = 15) => {
    const diffMinutes = differenceInMinutes(estimatedDate, scheduledDate);
    return diffMinutes > acceptableDifference;
  }

  return (
    <li className={`flight-list-item flight-list-item-${viewMode} ${isActive && !cancelled ? 'active' : ''} ${isSelected ? 'selected' : ''}`} >
      <Link to={location.pathname.replace(new RegExp(`/flights.*`, 'i'), `/flights/${data.id}`)}>
        <div className="left">
          <div className="city-name">{departure.cityName ?? departure.airportName}</div>
          <div className="date">{formatDate(scheduledDate)}</div>
          <div className={`time ${departureTimeTypeClassNames} ${differenceFromSchedule(depEstimated, depScheduled) ? 'alert' : ''}`}>{generateTimeStr(departureTimeTypeClassNames, scheduledDate)}</div>
        </div>
        <div className="center">
          <div className="icon"><FlightIcon className="icon-styling" /></div>
          <div className="flight-number">{`${flight.airlineCode ?? ""}${flight.flightNumber}`}</div>
        </div>
        <div className="right">
          <div className="city-name">{arrival.cityName ?? arrival.airportName}</div>
          <div className="date">{formatDate(arrivalDate)}</div>
          <div className={`time ${arrivalTimeTypeClassNames} ${differenceFromSchedule(arrEstimated, arrScheduled) ? 'alert' : ''}`}>{generateTimeStr(arrivalTimeTypeClassNames, arrivalDate)}</div>
        </div>
      </Link>
    </li>
  );
};

export default FlightListItem;
